<div class="ci-accessory-row mt-1">
  <div class="ci-accessory-label">
    @if (accessory.mandatory || accessory.bookAlways) {
      <span class="btt-label">{{ accessory.relatedProductName }}</span>
    } @else if (accessory.unlimited) {
      <label>{{ accessory.relatedProductName }}</label>
    } @else {
      <label nz-checkbox [ngModel]="accessory.selected" (ngModelChange)="toggle($event)">
        {{ accessory.relatedProductName }}
      </label>
    }
  </div>
  <div class="ci-accessory-price">
    @if (accessory.unlimited) {
      <nz-input-number
        [ngModel]="accessory.quantity"
        (ngModelChange)="updateQuantity($event)"
        [nzMin]="0"
        [nzMax]="9999"
        [nzStep]="1"
        [nzDisabled]="!accessory.available"
        [nzPlaceHolder]="'common.count' | actrans | str">
      </nz-input-number>
    }
    @if (accessory.amount != null && (accessory.selected || (accessory.unlimited && accessory.quantity > 0) || (!accessory.unlimited && accessory.mandatory))) {
      <span class="ml-1">{{ accessoryLineAmount() | nf }}</span>
    }
  </div>
</div>
@if ((accessory.selected || (accessory.unlimited && accessory.quantity > 0)) && accessory.orderTimeUserSelectable) {
  <div class="ml-8 my-4">
    <nz-form-item>
      <nz-form-label>{{ 'common.time' | actrans }}</nz-form-label>
      <nz-form-control>
        <nz-select
          [ngModel]="selectedTimeValue()"
          (ngModelChange)="onTimeChange($event)"
          (nzOpenChange)="loadTimeSlots()"
          nzAllowClear>
          @for (slot of accessory.timeSlots; track slot.timePeriod) {
            <nz-option [nzValue]="slot.startTime + '-' + slot.endTime" [nzLabel]="slot.timePeriod"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
}
@if ((accessory.selected || (accessory.unlimited && accessory.quantity > 0)) && accessory.inputValues.length) {
  <div class="ml-8 my-4">
    <btlib-order-input-fields [values]="accessory.inputValues" (valueChange)="onInputValueChange($event)"></btlib-order-input-fields>
  </div>
}
